import { render, staticRenderFns } from "./AccSetupLeftNavBar.vue?vue&type=template&id=748ec3e4&scoped=true"
import script from "./AccSetupLeftNavBar.vue?vue&type=script&lang=js"
export * from "./AccSetupLeftNavBar.vue?vue&type=script&lang=js"
import style0 from "./AccSetupLeftNavBar.vue?vue&type=style&index=0&id=748ec3e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748ec3e4",
  null
  
)

export default component.exports